export default "__VITE_ASSET__399deb38__"